import { useQuery } from 'react-query';
import axios from 'axios';

import { apiConfig } from '@constants';

import { replaceTemplateValues } from '../../helpers/StringUtils';

const getAlertTile = async ({ productKey, time, x, y, z }) => {
  const tileURL = replaceTemplateValues(apiConfig.TWC_API_MAP_ALERTS, {
    productKey,
    time,
    x,
    y,
    z,
  });

  const { data } = await axios.get(tileURL);

  return data;
};

export const useGetAlertTile = ({ productKey, time, x, y, z }) =>
  useQuery(`getAlertTile_${productKey}_${time}_${x}_${y}_${z}`, () => getAlertTile({ productKey, time, x, y, z }), {
    refetchOnWindowFocus: false,
  });
